import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LOGIN_SCREEN_ROUTE, START_SCREEN_ROUTE } from ".";
import { DashboardLayout } from "../layout/dashboard-layout";
const RequireAuth = () => {
  const auth = localStorage.getItem("pharmacyAuthToken");
  let location = useLocation();

  if (!auth) {
    return (
      // <Navigate to={LOGIN_SCREEN_ROUTE} state={{ from: location }} replace />
      <Navigate to={START_SCREEN_ROUTE} state={{ from: location }} replace />
    );
  }
  
  return (
    <>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </>
  );
};
export default RequireAuth;
